export default {
    countries: {},
    states: {},
    ratingSystems: {},
    ownerTypes: {},
    peerCampusUseTypes: {},
    peerUtilityUseTypes: {},
    peerTransitUseTypes: {},
    teamRoles: {},
    notifyPending: false,
    postalCodes: {}
}
